import './InitialScreen.css';
import Navbar from '../_Components/Navbar';
import calendar_icon from '../../assets/images/icons/calendar.svg';
import clock_icon from '../../assets/images/icons/clock.svg';
import Footer from '../_Components/Footer';
import { eventConfig } from '../../config/eventConfig';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleAddToCalendar } from '../../utils/calendar';
import { formatCountdown } from '../../utils';
import { useSessionActions, useIsEventDay, useIsEventStarted, useLiveUrl } from '../../context/SessionContext';
import { YouTubeIcon, SoundWaveIcon, InfoIcon } from '../../components/Icons';

function InitialScreen() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState('');
  const [sessionData, setSessionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { checkActiveSession } = useSessionActions();
  const isEventDay = useIsEventDay();
  const isEventStarted = useIsEventStarted();
  const liveUrl = useLiveUrl();

  useEffect(() => {
    const fetchActiveSession = async () => {
      try {
        setLoading(true);
        const result = await checkActiveSession();
        if (result && result.data) {
          setSessionData(result.data);
        }
      } catch (err) {
        console.error('Error fetching active session:', err);
        
        if (err.message === 'SESSION_COMPLETED' || err.isCompletion) {
          console.log('Session completed - navigating to /end');
          navigate('/end');
          return;
        }
        
        setSessionData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchActiveSession();
  }, [checkActiveSession, navigate]);

  useEffect(() => {
    if (!sessionData?.start_date) return;

    function updateCountdown() {
      const timeRemaining = Math.max(0, new Date(sessionData.start_date) - new Date());
      setCountdown(formatCountdown(timeRemaining));
      
      if (timeRemaining <= 0 || isEventStarted === true) {
        navigate('/start');
      }
    }

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, [sessionData?.start_date, isEventStarted, navigate]);

  return (
    <div className='initial-screen-bg'>
      <div id='container'>
        <Navbar />

        <div className='main-content'>
          {!loading && sessionData && isEventDay === true ? (
            <div className='live-section-container'>
              <a href={liveUrl || eventConfig.liveUrl} target='_blank' rel='noopener noreferrer' className='live-button'>
                <YouTubeIcon />
                Segui la live
                <SoundWaveIcon />
              </a>

              <div className='countdown-container'>
                <div className='responsive-countdown-text'>
                  <span className='desc-main'>Collegati in tempo per la</span>
                  <span className='desc-accent'> sessione accademica </span>
                  <span className='desc-main'>: esercizi interattivi su quesiti delle materie d'esame subito corretti dai docenti in aula.</span>

                  <br />
                  <br />
                  <span className='desc-main'>
                    Inizio previsto tra{' '}
                    <span className='desc-accent'>{countdown}</span>
                  </span>
                </div>

                <div>
                  <div className='session-details-link'>
                    <InfoIcon />

                    <div
                      className='session-details-text'
                      onClick={() => navigate('/start')}
                      role='button'
                      tabIndex={0}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter' || e.key === ' ')
                          navigate('/start');
                      }}
                    >
                      Dettagli sessione
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              className='event-details-box relative'
              style={{ paddingBottom: 50 }}
            >
              <div
                className='flex flex-col items-center gap-1'
                style={{ minWidth: '120px' }}
              >
                <img alt='Calendar Icon' src={calendar_icon} />
                <p className='text-xl'>{eventConfig.day}</p>
                <h3 className='h3'>{eventConfig.dateString}</h3>
              </div>

              <div
                className='flex flex-col items-center gap-1'
                style={{ minWidth: '60px' }}
              >
                <img alt='Clock Icon' src={clock_icon} />
                <p className='text-xl'>alle ore</p>
                <h3 className='h3'>{eventConfig.timeString}</h3>
              </div>

              <button className='calendar-button' onClick={() => handleAddToCalendar(eventConfig)}>
                Aggiungi a calendario
              </button>
            </div>
          )}
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default InitialScreen;
